import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  messages: [], // capped to last 20
  lastSeenTs: 0
};

function formatTimestamp(ts) {
  const msgDate = new Date(ts);
  const now = new Date();

  const isToday =
    msgDate.getDate() === now.getDate() &&
    msgDate.getMonth() === now.getMonth() &&
    msgDate.getFullYear() === now.getFullYear();

  return isToday
    ? msgDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    : msgDate.toLocaleDateString([], { day: '2-digit', month: '2-digit' }) +
        ' ' +
        msgDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

const slice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    addMessage(state, action) {
      const newMsg = {
        ...action.payload,
        formattedTimestamp: formatTimestamp(action.payload.timestamp)
      };
      const exists = state.messages.some(
        msg =>
          msg.timestamp === newMsg.timestamp &&
          msg.sender === newMsg.sender &&
          msg.tabId === newMsg.tabId
      );

      if (exists) return;

      state.messages.push(newMsg);

      // keep only last 20 messages
      if (state.messages.length > 20) {
        state.messages.splice(0, state.messages.length - 20);
      }
    },

    setLastSeenTs(state, action) {
      const newTs = action.payload;
      state.lastSeenTs = newTs;
    },
    clearChat(state) {
      state.messages = [];
    },

    restoreChat(_, action) {
      return action.payload || initialState;
    }
  }
});

const chatReducer = slice.reducer;

export const {
  addMessage,
  clearChat,
  restoreChat,
  setLastSeenTs
} = slice.actions;
export default chatReducer;
